import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { environment } from '@env/environment';
import { GhGlobal } from '@shared/helpers/global-functions';
import { ISocialShare } from '@core/seo/social-share/social-share.interface';
import { Location } from '@angular/common';
import { JsonLdService } from '@core/seo/json-ld/json-ld.service';
import { MetaTagAttr } from '@core/seo/social-share/meta-tag.interface';
import { SocialShareService, TrackingService } from '@core/services';

@Component({
    selector: 'gh-not-found',
    templateUrl: 'not-found.component.html',
    standalone: false
})

export class NotFoundComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private jsonLdService: JsonLdService,
    private socialShareService: SocialShareService,
    protected location: Location,
    private trackingService: TrackingService,
  ) { }

  ngOnInit() {
    GhGlobal.injectStyle('', this.document);
    this.setSeoData();
  }

  private setSeoData() {
    const seoData: ISocialShare = {
      title: 'GoHenry | blog - not found',
      keywords: `gohenry,blog,404`,
      description: 'The GoHenry pocket money card is a smart solution for managing your child\'s money and giving money to children, through an allowance prepaid card.',
      image: environment.socialImage,
      url: environment.location + '/404',
      type: 'article:not-found',
      author: 'gohenry',
      section: '404',
      published: '',
      modified: ''
    };

    const jsonLdObject = this.jsonLdService.getObject('Website', {
      name: 'GoHenry | Making every kid good with money – blog',
      url: seoData.url,
      description: 'The GoHenry pocket money card is a smart solution for managing your child\'s money and giving money to children, through an allowance prepaid card.'
    });

    const jsonLdObject2 = this.jsonLdService.getObject('Organization', {
      url: environment.website,
      logo: environment.jsonImage,
      legalName: 'GoHenry',
      name: 'GoHenry'
    });

    this.socialShareService.setData(seoData);
    this.socialShareService.setMetaTag({
      attr: MetaTagAttr.name, attrValue: 'robots', value: 'noindex, nofollow'
    });
    this.jsonLdService.setData([jsonLdObject, jsonLdObject2]);
    this.trackingService.setDataLayerAttributes({
      event: 'pageView',
      event_name: 'page_view',
      page: {
        location: this.location.path(),
        environment: environment.env,
        locale: environment.locale,
        title: seoData.title,
        feature: 'blog',
      }
    });
  }
}
